import useScriptFlag from '@/hooks/useScriptFlag';
import { useEffect } from 'react';

// @refresh reset
export default function InterstitialsAds() {
  const shouldRenderAds = useScriptFlag({ adFlag: 'google' });

  useEffect(() => {
    window.googletag = window.googletag || { cmd: [] };

    let interstitialSlot: googletag.Slot | null;

    if (shouldRenderAds) {
      googletag.cmd.push(() => {
        interstitialSlot = googletag.defineOutOfPageSlot('/22189562696/Interstitial_2023', googletag.enums.OutOfPageFormat.INTERSTITIAL);

        interstitialSlot.addService(googletag.pubads());

        if (interstitialSlot) {
          interstitialSlot.setConfig({
            interstitial: {
              triggers: {
                unhideWindow: true,
              },
            },
          });

          googletag.display(interstitialSlot);
          // Ao usar disableInitialLoad(), depois de chamar display no espaço, a solicitação de anúncio ainda precisa ser acionada chamando refresh()
          googletag.pubads().refresh([interstitialSlot]);
        }
      });
    }
  });

  return null;
}
